export default __webpack_public_path__ + "static/media/dispatch.cf2e55dc.mp3";